// ** MUI Imports
import { styled } from '@mui/material/styles'
import Box, { BoxProps } from '@mui/material/Box'

type ReactHotToastOwnerState = {
  layout?: 'horizontal' | 'vertical'
  navHidden?: boolean
}

const ReactHotToast = styled(Box, {
  shouldForwardProp: prop => prop !== 'ownerState'
})<BoxProps & { ownerState?: ReactHotToastOwnerState }>(({ theme, ownerState }) => {
  const layout = ownerState?.layout ?? 'vertical'
  const navHidden = ownerState?.navHidden ?? false

  const topInset = layout === 'horizontal' && !navHidden ? '139px' : '75px'
  const gutter = `${theme.spacing(6)}`

  /** Sync with `GlobalToaster` (`position='top-right'`): top-right gutter under app chrome. z-index comes from Toaster `containerStyle`. */
  return {
    '& > div': {
      top: `${topInset} !important`,
      right: `${gutter} !important`,
      left: 'auto !important',
      bottom: 'auto !important',
      transform: 'none !important'
    },
    '& .react-hot-toast': {
      fontWeight: 400,
      letterSpacing: '0.14px',
      boxShadow: theme.shadows[4],
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      fontSize: theme.typography.body1.fontSize,
      background: theme.palette.background.paper,
      '&>:first-of-type:not([role])>:first-of-type': {
        width: 14,
        height: 14
      }
    }
  }
})

export default ReactHotToast
